/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { ICON_BUTTON__ICON_CLASS } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const accordion = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const accordionTitleWrapper = css`
  margin: 0;
`;

export const accordionButton = css`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  background: none;
  border: none;

  .${ICON_BUTTON__ICON_CLASS} {
    transform: rotate(180deg);
    transition: transform 0.5s;
  }
  &[data-is-open='true'] {
    .${ICON_BUTTON__ICON_CLASS} {
      transform: rotate(0deg);
    }
  }

  @media (hover: hover) {
    &:hover {
      background: none;
    }
  }
`;

export const accordionTitle = css`
  margin-right: ${pxToRem(spacing.sm)};
  text-transform: capitalize;
`;

export const accordionContentWrapper = css`
  .js & {
    width: 100%;
    transition: height 0.5s;
    height: 0;
    overflow: hidden;
    > div {
      margin-top: ${pxToRem(spacing.xl)};
    }
  }
`;
